import Image from "next/image";
import { AnalysisCard } from "./AnalysisCard";
import { GeneratedLessonPlanCard } from "./GeneratedLessonPlanCard";
import { TextbookUploadedCard } from "./TextbookUploadedCard";

export type ProofShowcaseCopy = {
  textbook: {
    number: string;
    title: string;
    image: {
      src: string;
      alt: string;
      width: number;
      height: number;
    };
  };
  analysis: {
    title: string;
    items: readonly string[];
    readyLabel: string;
  };
  lessonPlan: {
    title: string;
    documentTitle: string;
    meta: readonly {
      label: string;
      value: string;
    }[];
    objectives: readonly string[];
    materials: string;
    sectionLabels: {
      objectives: string;
      materials: string;
    };
    tableHeaders: readonly [string, string, string, string, string];
    stages: readonly {
      stage: string;
      activity: string;
      procedures: readonly string[];
      time: string;
      interaction: string;
    }[];
    exportLabel: string;
    printLabel: string;
  };
};

type ProofShowcaseProps = {
  copy: ProofShowcaseCopy;
  compact?: boolean;
};

export function ProofShowcase({ copy, compact = false }: ProofShowcaseProps) {
  return (
    <div id="full-lesson-example" className="relative mx-auto mt-8 max-w-[1620px] lg:mt-9">
      <div className={`grid gap-4 lg:grid-cols-[minmax(285px,0.82fr)_minmax(210px,0.48fr)_minmax(460px,1.18fr)] lg:items-start ${compact ? "lg:gap-8" : "lg:gap-24"}`}>
        <TextbookUploadedCard copy={copy.textbook} compact={compact} className="lg:mt-7" />
        <AnalysisCard copy={copy.analysis} compact={compact} className="lg:mt-16" />
        <GeneratedLessonPlanCard copy={copy.lessonPlan} compact={compact} />
      </div>

      <Image
        src="/images/landing/hand-drawn-arrow-right.png"
        alt=""
        width={1766}
        height={1106}
        className="pointer-events-none absolute z-10 left-[30.2%] top-[315px] hidden h-[54px] w-[86px] object-contain lg:block"
        aria-hidden
      />
      <Image
        src="/images/landing/hand-drawn-arrow-right.png"
        alt=""
        width={1766}
        height={1106}
        className="pointer-events-none absolute z-10 left-[52.7%] top-[315px] hidden h-[54px] w-[86px] object-contain lg:block"
        aria-hidden
      />
    </div>
  );
}
